exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".con,.crumbs{width:1200px;margin:0 auto}.crumbs{height:20px;line-height:20px;padding:30px 0;color:#7e7e7e}.cru_icon{width:6px;height:16px;background-color:#d3253e;border-radius:10px;float:left;margin-top:2PX}.cru_p{float:left;font-size:14px;padding-left:10px}.con_box{width:1040px;margin:0 auto;background:#fff;padding:80px}.con_box h2{font-size:24px;text-align:center;padding-bottom:50px}.con_box h2,.con_box h3{color:#333;line-height:30px}.con_box h3{font-size:20px;padding-top:50px;padding-bottom:20px}.con_box p{line-height:30px;font-size:16px}", ""]);

// exports
